/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Document_RenamedInputs */

const cs_enum_document_renamed = /** @type {(inputs: Enum_Document_RenamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument přejmenován`)
};

const en_enum_document_renamed = /** @type {(inputs: Enum_Document_RenamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document renamed`)
};

/**
* | output |
* | --- |
* | "Document renamed" |
*
* @param {Enum_Document_RenamedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_document_renamed = /** @type {((inputs?: Enum_Document_RenamedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Document_RenamedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_document_renamed(inputs)
	return cs_enum_document_renamed(inputs)
});